import React, { useRef } from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../../BlockBuilder';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import { isListingFavorited } from '../../../../util/favorites';

import SectionContainer from '../SectionContainer';
import css from './SectionShopByCategory.module.css';

// The number of columns affects responsive image sizes
const COLUMN_CONFIG = [
  { responsiveImageSizes: '(max-width: 767px) 100vw, 1200px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 600px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 400px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 265px' },
];

const getIndex = numColumns => numColumns - 1;

const getResponsiveImageSizes = numColumns => {
  const config = COLUMN_CONFIG[getIndex(numColumns)];

  return config
    ? config.responsiveImageSizes
    : COLUMN_CONFIG[0].responsiveImageSizes;
};

/**
 * Allows accent-colored words using **...** in CMS content.
 *
 * Example:
 * "COMPRA POR **CATEGORÍA**"
 *
 * The word inside **...** gets the titleAccent class.
 */
const AccentTitle = ({ data }) => {
  if (!data?.content) {
    return null;
  }

  const parts = data.content.split(/\*\*(.*?)\*\*/g);

  return (
    <h2 className={css.title}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className={css.titleAccent}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </h2>
  );
};

const SectionShopByCategory = props => {
  const {
    sectionId,
    className,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    secondaryCallToAction,
    blocks = [],
    options,

    currentUser,
    onToggleFavorite,
    onRequireLogin,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields(
    [title, description, callToAction],
    fieldOptions
  );

  const hasBlocks = blocks?.length > 0;

const sliderRef = useRef(null);

const slide = direction => {
  const slider = sliderRef.current;
  if (!slider) return;
  slider.scrollBy({
    left: direction * slider.clientWidth,
    behavior: 'smooth',
  });
};

  return (
    <SectionContainer
      id={sectionId}
      rootClassName={css.root}
      className={className}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <div className={css.headerRow}>
          <div className={css.titleCol}>
            <AccentTitle data={title} />
          </div>

          <div className={css.metaCol}>
            <Field
              data={description}
              className={css.description}
              options={fieldOptions}
            />

            <div className={css.ctaRow}>
              <Field
                data={callToAction}
                className={css.ctaButton}
                options={fieldOptions}
              />

              {secondaryCallToAction ? (
                <Field
                  data={secondaryCallToAction}
                  className={css.ctaSecondary}
                  options={fieldOptions}
                />
              ) : null}
            </div>
          </div>
        </div>
      ) : null}

{hasBlocks ? (
  <div className={css.carouselContainer}>
    <button
      type="button"
      className={css.carouselArrowPrev}
      onClick={() => slide(-1)}
      aria-label="Anterior"
    >
      ‹
    </button>
    <button
      type="button"
      className={css.carouselArrowNext}
      onClick={() => slide(1)}
      aria-label="Siguiente"
    >
      ›
    </button>

    <div className={css.categoriesRow} ref={sliderRef}>
      {blocks.map((block, index) => {
        const id = block?.id?.uuid || block?.id || `${sectionId}-${index}`;
        const categoryTitle =
          block?.title?.content || block?.title || block?.name || '';

        return (
          <div key={id} className={css.categoryItem}>
            <div className={css.categoryImage}>
              <BlockBuilder
                blocks={[block]}
                sectionId={sectionId}
                responsiveImageSizes={getResponsiveImageSizes(numColumns)}
                options={options}
              />

              {categoryTitle ? (
                <div className={css.categoryTitle}>
                  {categoryTitle}
                  <span className={css.categoryArrow}>→</span>
                </div>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  </div>
) : null}
    </SectionContainer>
  );
};

export default SectionShopByCategory;